import { Button, Divider, Stack } from "@mui/material";
import { PersonalInfo } from "./partials/PersonalInfo";
import { ChangePassword } from "./partials/ChangePassword";
import { useAppSelector } from "../../store/hooks";
import { selectExtension } from "../../features/extension/extension.selector";
import { useLogout } from "../../hooks/useLogout";

const MyDetails = () => {
  const { isExtension } = useAppSelector(selectExtension);
  const { logout, loading: loggingOut } = useLogout();

  const handleLogout = async () => {
    window.open(
      `${process.env.REACT_APP_SERVER_URL}/logout?from=extension`,
      "_blank",
      "noopener,noreferrer",
    );
    // await logout();
    // if (
    //   typeof chrome !== "undefined" &&
    //   typeof chrome.runtime !== "undefined"
    // ) {
    //   chrome.runtime.sendMessage({ type: "logout" });
    // }
  };

  return (
    <Stack gap={isExtension ? 1.5 : 3}>
      <PersonalInfo />
      <Divider />
      <ChangePassword />
      {isExtension && (
        <>
          <Divider />
          <Button
            variant="contained"
            loading={loggingOut}
            onClick={handleLogout}
          >
            Logout
          </Button>
        </>
      )}
    </Stack>
  );
};

export default MyDetails;
